import React from "react";
import { PageHeader } from "./PageHeader"
import { DataBox } from "./DataBox"
import { useMaintenanceModel } from "../maintenanceModel";
import { AllSettleDrawer } from "./allSettleDrawer";
export default () => {
    const {
        print,
        scaniaPrint: { visible },
        settleScaniaPrint,
    } = useMaintenanceModel();
    return (
        <>
            <PageHeader />
            <DataBox />
            <AllSettleDrawer />
        </>
    )
}